import { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { getPedido } from '../services/api';

const ETAPAS = [
  { status: 'aguardando', label: 'Pedido recebido', icon: '📋' },
  { status: 'aceito', label: 'Pedido aceito', icon: '✅' },
  { status: 'preparo', label: 'Em preparo', icon: '🔥' },
  { status: 'pronto', label: 'Pronto para retirada', icon: '🎉' },
  { status: 'entregando', label: 'Saiu para entrega', icon: '🛵' },
  { status: 'entregue', label: 'Entregue!', icon: '🏁' },
];
const ORDEM = ['aguardando','aceito','preparo','pronto','entregando','entregue'];

export default function PedidoDetalhes() {
  const { id } = useParams();
  const [pedido, setPedido] = useState(null);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    const carregar = () => getPedido(id).then(r => setPedido(r.data)).finally(() => setLoading(false));
    carregar();
    const interval = setInterval(carregar, 15000);
    return () => clearInterval(interval);
  }, [id]);

  if (loading) return <div style={{ padding: 16 }}><div className="spinner" /></div>;
  if (!pedido) return <div style={{ padding: 16 }}><p>Pedido não encontrado</p></div>;

  const statusIdx = ORDEM.indexOf(pedido.status);

  return (
    <div style={{ padding: 16 }}>
      <button onClick={() => navigate('/pedidos')} style={{ background: 'none', border: 'none', color: 'var(--text2)', cursor: 'pointer', fontSize: 13, marginBottom: 12, fontFamily: 'Nunito,sans-serif' }}>← Voltar</button>
      <div style={{ background: 'var(--bg3)', border: '1px solid var(--border)', borderRadius: 12, padding: 16, marginBottom: 16 }}>
        <div style={{ fontSize: 12, color: 'var(--text2)', marginBottom: 4 }}>Pedido #{pedido.id} • {new Date(pedido.criado_em).toLocaleString('pt-BR')}</div>
        <div style={{ fontWeight: 800, fontSize: 18, color: 'var(--orange)', marginBottom: 10 }}>R$ {parseFloat(pedido.total).toFixed(2).replace('.', ',')}</div>
        <div style={{ fontSize: 12, color: 'var(--text2)', marginBottom: 14 }}>
          {pedido.itens?.map(i => `${i.emoji} ${i.nome} x${i.quantidade}`).join(' · ')}
        </div>

        {/* Timeline */}
        <div>
          {ETAPAS.map((etapa, i) => {
            const done = i < statusIdx, active = i === statusIdx;
            return (
              <div key={etapa.status} style={{ display: 'flex', gap: 10, position: 'relative' }}>
                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', width: 32, flexShrink: 0 }}>
                  <div style={{
                    width: 32, height: 32, borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 14, flexShrink: 0,
                    background: done ? 'linear-gradient(135deg,var(--red),var(--orange))' : active ? 'var(--orange)' : 'var(--bg4)',
                    border: active ? '2px solid var(--orange)' : done ? 'none' : '2px solid var(--border)',
                    boxShadow: active ? '0 0 0 4px rgba(255,107,0,.2)' : 'none',
                    color: done || active ? '#fff' : 'var(--text3)'
                  }}>{done ? '✓' : etapa.icon}</div>
                  {i < ETAPAS.length - 1 && <div style={{ width: 2, flex: 1, minHeight: 20, background: i < statusIdx ? 'var(--orange)' : 'var(--border)', margin: '2px 0' }} />}
                </div>
                <div style={{ paddingBottom: 16, paddingTop: 4 }}>
                  <div style={{ fontSize: 13, fontWeight: 700, color: i <= statusIdx ? 'var(--text)' : 'var(--text3)' }}>{etapa.label}</div>
                  {active && <div style={{ fontSize: 11, color: 'var(--orange)' }}>Atualizando em tempo real...</div>}
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
}
